import { render, staticRenderFns } from "./ResourceRoomType.vue?vue&type=template&id=3b55a0e9&"
import script from "./ResourceRoomType.vue?vue&type=script&lang=js&"
export * from "./ResourceRoomType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports